import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Todos } from '../models/todos';
import { HttpService } from '../services/json.service';

@Component({
  selector: 'app-api-connection-detail',
  templateUrl: './api-connection-detail.component.html',
  styleUrls: ['./api-connection-detail.component.css']
})
export class ApiConnectionDetailComponent implements OnInit {

  todos: Todos[];
  id: string;
  sub: any;

  loading: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private httpService : HttpService
  ) { }

  ngOnInit(): void {
    this.sub = this.activatedRoute.params.subscribe(params => {
      this.id = params['id'];
      this.getDataFromAPI();
    });
  }

  public getDataFromAPI(){
    this.loading = true;
    this.httpService.getList(this.id).subscribe(
      (response) => {
        console.log(response);
        this.todos = response.filter(resp => resp.completed === false);
        this.loading = false;
      }, 
      (error) => {
        console.error(error);
        console.log('Failed request');
        this.loading = false;
      }
    )
  }
}
